import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { userLogout } from "../../store/actions/authActions";
import {  Button } from 'reactstrap';
class Signout extends Component {

    
    onSignoutClicked = () => {
        this.props.userLogout();
        this.props.history.push("/Signin")
    }


    render() {
        return (

            <Button className="buttonWebSite" size="sm" style={{ "margin": "3px" }}
                    onClick={this.onSignoutClicked}
                >Sign Out</Button>
           
        );
    }
}


Signout = connect(null, { userLogout })(withRouter(Signout));


export default Signout;




// WEBPACK FOOTER //
// ./src/components/auth/Signout.js